export const RULERS_CSS = `
  /* ── Ruler bars ── */
  [data-string-rulers-top],
  [data-string-rulers-left] {
    position: absolute;
    z-index: 3;
    display: block;
    cursor: crosshair;
    image-rendering: pixelated;
    transition: opacity 0.15s ease;
  }

  [data-string-rulers-top] {
    top: 0; left: 0;
    width: 100%; height: 20px;
    pointer-events: auto;
  }

  [data-string-rulers-left] {
    top: 0; left: 0;
    width: 20px; height: 100%;
    pointer-events: auto;
  }

  /* ── Corner mode toggle ── */
  [data-string-rulers-corner] {
    position: absolute;
    top: 0; left: 0;
    width: 20px; height: 20px;
    z-index: 4;
    background: var(--string-dg-color-cloud-white);
    border: 1px solid var(--string-dg-color-middle-white);
    border-radius: var(--string-dg-panel-button-radius);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: auto;
    cursor: pointer;
    transition: opacity 0.15s ease, background 0.15s ease;
  }

  [data-string-rulers-corner]:hover {
    background: var(--string-dg-color-grey-1);
  }

  [data-string-rulers-corner][data-mode="center"] {
    background: var(--string-dg-color-grey-2);
  }
  [data-string-rulers-corner][data-mode="center"]:hover {
    background: var(--string-dg-color-grey-3);
  }

  [data-string-rulers-corner] > span {
    font: 10px "JetBrains Mono", monospace;
    color: var(--string-dg-color-grey-6, #888888);
    white-space: nowrap;
    line-height: 1;
    pointer-events: none;
    user-select: none;
  }

  [data-string-rulers-corner][data-mode="center"] > span {
    color: var(--string-dg-color-blue, #3B82F6);
  }

  @media (max-width: 1024px) {
    [data-string-rulers-top] {
      height: 12px;
    }

    [data-string-rulers-left] {
      width: 12px;
    }

    [data-string-rulers-corner] {
      width: 12px;
      height: 12px;
      border-radius: 6px;
    }

    [data-string-rulers-corner] > span {
      font-size: 8px;
    }
  }

  /* ── Layout grid canvas ── */
  [data-string-rulers-grid] {
    position: absolute;
    top: 0; left: 0;
    z-index: 1;
    pointer-events: none;
    image-rendering: pixelated;
    transition: opacity 0.15s ease;
  }

  /* ── Lines layer ── */
  [data-string-rulers-lines] {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 2;
    overflow: hidden;
  }

  /* ── Guide lines ── */
  [data-string-rulers-line] {
    position: absolute;
    pointer-events: auto;
    opacity: var(--string-rulers-line-opacity, 1);
  }

  [data-string-rulers-line][data-axis="horizontal"] {
    border-top: 1px solid var(--string-rulers-line-color, rgba(0, 120, 255, 0.4));
    height: 0;
    cursor: row-resize;
  }

  [data-string-rulers-line][data-axis="vertical"] {
    border-left: 1px solid var(--string-rulers-line-color, rgba(0, 120, 255, 0.4));
    width: 0;
    cursor: col-resize;
  }

  /* ── Expanded hit area via ::before ──
     Adds 5px grab zone above/below horizontal lines,
     and 5px left/right of vertical lines — no change to visuals. */
  [data-string-rulers-line][data-axis="horizontal"]::before {
    content: '';
    display: block;
    position: absolute;
    left: 0; right: 0;
    top: -5px;
    height: 11px;
  }

  [data-string-rulers-line][data-axis="vertical"]::before {
    content: '';
    display: block;
    position: absolute;
    top: 0; bottom: 0;
    left: -5px;
    width: 11px;
  }

  [data-string-rulers-line]:hover {
    border-color: rgba(255, 60, 60, 0.5);
  }

  /* ── Coordinate label ── */
  [data-string-rulers-label] {
    position: absolute;
    top: 2px; left: 24px;
    padding: 2px 2px;
    background-color: var(--string-dg-color-blue);
    color: var(--string-dg-color-white);
    font-size: var(--string-dg-font-size-xs);
    font-weight: var(--string-dg-font-medium);
    line-height: 1;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    box-sizing: border-box;
    pointer-events: none;
    white-space: nowrap;
  }

  [data-string-rulers-line][data-axis="vertical"] [data-string-rulers-label] {
    top: 24px; left: 2px;
    writing-mode: vertical-lr;
  }

  /* ── Snap: ELEMENT (amber) ── */
  [data-string-rulers-line][data-snapping="element"][data-axis="horizontal"] {
    border-top-color: rgba(220, 120, 0, 0.5);
  }
  [data-string-rulers-line][data-snapping="element"][data-axis="vertical"] {
    border-left-color: rgba(220, 120, 0, 0.5);
  }
  [data-string-rulers-line][data-snapping="element"] [data-string-rulers-label] {
    background-color: var(--string-dg-color-amber, rgba(180, 80, 0, 0.95));
    color: var(--string-dg-color-white);
  }

  /* ── Snap: GRID (green) ── */
  [data-string-rulers-line][data-snapping="grid"][data-axis="horizontal"] {
    border-top-color: rgba(0, 170, 80, 0.5);
  }
  [data-string-rulers-line][data-snapping="grid"][data-axis="vertical"] {
    border-left-color: rgba(0, 170, 80, 0.5);
  }
  [data-string-rulers-line][data-snapping="grid"] [data-string-rulers-label] {
    background-color: var(--string-dg-color-green, rgba(0, 130, 60, 0.95));
    color: var(--string-dg-color-white);
  }

  /* ── Snap: GUIDE GAP (cyan) ── */
  [data-string-rulers-line][data-snapping="guide"][data-axis="horizontal"] {
    border-top-color: rgba(0, 150, 170, 0.5);
  }
  [data-string-rulers-line][data-snapping="guide"][data-axis="vertical"] {
    border-left-color: rgba(0, 150, 170, 0.5);
  }
  [data-string-rulers-line][data-snapping="guide"] [data-string-rulers-label] {
    background-color: var(--string-dg-color-teal, rgba(0, 120, 140, 0.95));
    color: var(--string-dg-color-white);
  }

  /* ── Snap: COLUMN (magenta) ── */
  [data-string-rulers-line][data-snapping="column"][data-axis="horizontal"] {
    border-top-color: rgba(200, 0, 100, 0.5);
  }
  [data-string-rulers-line][data-snapping="column"][data-axis="vertical"] {
    border-left-color: rgba(200, 0, 100, 0.5);
  }
  [data-string-rulers-line][data-snapping="column"] [data-string-rulers-label] {
    background-color: var(--string-dg-color-crimson, rgba(160, 0, 80, 0.95));
    color: var(--string-dg-color-white);
  }

  /* ── Guide-gap references ── */
  [data-string-rulers-line][data-string-rulers-guide-ref][data-axis="horizontal"] {
    border-top-color: rgba(0, 150, 170, 0.35);
  }
  [data-string-rulers-line][data-string-rulers-guide-ref][data-axis="vertical"] {
    border-left-color: rgba(0, 150, 170, 0.35);
  }

  [data-string-rulers-gap-indicator] {
    
    position: absolute;
    pointer-events: none;
    z-index: 4;
  }

  [data-string-rulers-gap-indicator][data-axis="vertical"] {
    border-top: 1px dashed rgba(0, 150, 170, 0.5);
  }

  [data-string-rulers-gap-indicator][data-axis="horizontal"] {
    border-left: 1px dashed rgba(0, 150, 170, 0.5);
  }

  [data-string-rulers-gap-indicator-label] {
    position: absolute;
    font-size: var(--string-dg-font-size-s);
    font-weight: var(--string-dg-font-medium);
    color: var(--string-dg-color-white);
    background: var(--string-dg-color-teal, rgba(0, 120, 140, 0.95));
    padding: 2px 4px;
    white-space: nowrap;
    line-height: 1;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    box-sizing: border-box;
  }

  [data-string-rulers-gap-indicator][data-axis="vertical"] [data-string-rulers-gap-indicator-label] {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  [data-string-rulers-gap-indicator][data-axis="horizontal"] [data-string-rulers-gap-indicator-label] {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  /* ── Snap target element highlight ── */
  [data-string-rulers-snap-target] {
    outline: 1px dashed rgba(220, 120, 0, 0.3) !important;
    outline-offset: 0px;
  }

  /* ── Ghost (preview during drag from ruler) ── */
  [data-string-rulers-ghost] {
    color: var(--string-dg-color-white);
    font-size: var(--string-dg-font-size-xs);
    font-weight: var(--string-dg-font-medium);
    position: absolute;
    pointer-events: none;
    opacity: calc(var(--string-rulers-line-opacity, 1) * 0.45);
  }

  [data-string-rulers-ghost][data-axis="horizontal"] {
    border-top: 1px dashed var(--string-rulers-line-color, rgba(0, 120, 255, 0.4));
    height: 0;
  }

  [data-string-rulers-ghost][data-axis="vertical"] {
    border-left: 1px dashed var(--string-rulers-line-color, rgba(0, 120, 255, 0.4));
    width: 0;
  }

  /* Ghost snap: ELEMENT (amber) */
  [data-string-rulers-ghost][data-snapping="element"][data-axis="horizontal"] {
    border-top-style: solid;
    border-top-color: rgba(220, 120, 0, 0.5);
    opacity: 0.55;
  }
  [data-string-rulers-ghost][data-snapping="element"][data-axis="vertical"] {
    border-left-style: solid;
    border-left-color: rgba(220, 120, 0, 0.5);
    opacity: 0.55;
  }

  /* Ghost snap: GRID (green) */
  [data-string-rulers-ghost][data-snapping="grid"][data-axis="horizontal"] {
    border-top-style: solid;
    border-top-color: rgba(0, 170, 80, 0.5);
    opacity: 0.55;
  }
  [data-string-rulers-ghost][data-snapping="grid"][data-axis="vertical"] {
    border-left-style: solid;
    border-left-color: rgba(0, 170, 80, 0.5);
    opacity: 0.55;
  }

  /* Ghost snap: COLUMN (magenta) */
  [data-string-rulers-ghost][data-snapping="column"][data-axis="horizontal"] {
    border-top-style: solid;
    border-top-color: rgba(200, 0, 100, 0.5);
    opacity: 0.55;
  }
  [data-string-rulers-ghost][data-snapping="column"][data-axis="vertical"] {
    border-left-style: solid;
    border-left-color: rgba(200, 0, 100, 0.5);
    opacity: 0.55;
  }

  /* Ghost snap: GUIDE GAP (cyan) */
  [data-string-rulers-ghost][data-snapping="guide"][data-axis="horizontal"] {
    border-top-style: solid;
    border-top-color: rgba(0, 150, 170, 0.5);
    opacity: 0.55;
  }
  [data-string-rulers-ghost][data-snapping="guide"][data-axis="vertical"] {
    border-left-style: solid;
    border-left-color: rgba(0, 150, 170, 0.5);
    opacity: 0.55;
  }

  /* ── Ghost coordinate label ── */
  [data-string-rulers-ghost-label] {
    position: absolute;
    font-size: var(--string-dg-font-size-xs);
    font-weight: var(--string-dg-font-medium);
    color: var(--string-dg-color-white);
    background: var(--string-dg-color-blue);
    padding: 2px 4px;
    pointer-events: none;
    white-space: nowrap;
    line-height: 1;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    box-sizing: border-box;
  }

  [data-string-rulers-ghost][data-snapping="element"] [data-string-rulers-ghost-label] {
    background-color: var(--string-dg-color-amber, rgba(180, 80, 0, 0.95));
    color: var(--string-dg-color-white);
  }
  [data-string-rulers-ghost][data-snapping="grid"] [data-string-rulers-ghost-label] {
    background-color: var(--string-dg-color-green, rgba(0, 130, 60, 0.95));
    color: var(--string-dg-color-white);
  }
  [data-string-rulers-ghost][data-snapping="guide"] [data-string-rulers-ghost-label] {
    background-color: var(--string-dg-color-teal, rgba(0, 120, 140, 0.95));
    color: var(--string-dg-color-white);
  }
  [data-string-rulers-ghost][data-snapping="column"] [data-string-rulers-ghost-label] {
    background-color: var(--string-dg-color-crimson, rgba(160, 0, 80, 0.95));
    color: var(--string-dg-color-white);
  }

  [data-axis="horizontal"] [data-string-rulers-ghost-label] {
    top: 3px; left: 24px;
  }
  [data-axis="vertical"] [data-string-rulers-ghost-label] {
    left: 3px; top: 24px;
  }

  /* ── Fixed guide lines (center cross, etc.) ── */
  [data-string-rulers-fixed-line] {
    position: absolute;
    pointer-events: none;
  }

  [data-string-rulers-fixed-line][data-axis="horizontal"] {
    border-top: 1px dashed rgba(100, 100, 100, 0.18);
    height: 0;
  }

  [data-string-rulers-fixed-line][data-axis="vertical"] {
    border-left: 1px dashed rgba(100, 100, 100, 0.18);
    width: 0;
  }

  /* ── Hidden state ── */
  [data-string-rulers-hidden] [data-string-rulers-grid],
  [data-string-rulers-hidden] [data-string-rulers-top],
  [data-string-rulers-hidden] [data-string-rulers-left],
  [data-string-rulers-hidden] [data-string-rulers-corner],
  [data-string-rulers-hidden] [data-string-rulers-lines],
  [data-string-rulers-hidden] [data-string-rulers-line],
  [data-string-rulers-hidden] [data-string-rulers-fixed-line],
  [data-string-rulers-hidden] [data-string-rulers-gap-indicator],
  [data-string-rulers-hidden] [data-string-rulers-ghost] {
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
  }
`;
